import HomeV3 from './pages/HomeV3';
import Help from './pages/Help/index.js';
import Admin from './pages/Admin/index.js';
import Documents from './pages/Documents/index.js';
import FleetManagement from './pages/FleetManagement/index.js';
import Forgot from './pages/Forgot/index.js';
import Login from './pages/Login/index.js';
import Messaging from './pages/Messaging/index.js';
import Reserves from './pages/Reserves/index.js';
import ResetPassword from './pages/ResetPassword/index.js';
import Tour from './pages/Tour/index.js';
import Users from './pages/Users/index.js';
import Validation from './pages/Validation/index.js';
import Vehicles from './pages/Vehicles/index.js';
import Warehouses from './pages/Warehouses/index.js';
import AddFile from './pages/FileImport/AddFile/index.js';
import ApiLogsPage from './pages/Logs/index.js';
import ReserveReasons from './pages/ReserveReasons/index.js';
import PhoneNumbers from './pages/PhoneNumbers/index.js';
import Addresses from './pages/Addresses/index.js';
import OrdersPool from './pages/OrdersPool/index.js';
import TruckAssignments from './pages/TruckAssignments/index.js';

export const navigationRoutes = [
  {
    title: 'CONNEXION',
    need_authentication: false,
    routes: [
      {
        url_path: '/login',
        section_title: 'Login',
        component: Login,
      },
      {
        url_path: '/help',
        section_title: 'Help',
        component: Help,
      },
    ],
  },
  {
    title: 'PILOTAGE',
    need_authentication: true,
    routes: [
      {
        url_path: '/',
        section_title: 'Tableau de bord',
        component: HomeV3,
      },
      {
        url_path: '/orders-pool',
        section_title: 'Puits de commande',
        component: OrdersPool,
        feature_path: 'TOUR_PLANNING.ORDERS_POOL.enabled',
      },
      {
        url_path: '/truck-assignments',
        section_title: 'Affectations Camion',
        component: TruckAssignments,
        feature_path: 'TOUR_PLANNING.TRUCK_ASSIGNMENTS.enabled',
      },
      {
        url_path: '/tours',
        section_title: 'Tournées',
        component: Tour,
      },
      {
        url_path: '/vehicles',
        section_title: 'Véhicules',
        component: Vehicles,
      },
      {
        url_path: '/warehouses',
        section_title: 'Entrepôts',
        component: Warehouses,
        feature_path: 'TOUR_PLANNING.WAREHOUSES.enabled',
      },
      {
        url_path: '/reserves',
        section_title: 'Réserves',
        component: Reserves,
      },
      {
        url_path: '/messaging',
        section_title: 'Messagerie',
        component: Messaging,
        feature_path: 'TOUR_MANAGEMENT.CHAT.enabled',
      },
    ],
  },
  {
    title: 'SUPPORT',
    need_authentication: true,
    routes: [
      {
        url_path: '/logs',
        section_title: 'Statut API',
        component: ApiLogsPage,
        client_id_required: 5,
      },
    ],
  },
  {
    title: 'GESTION',
    need_authentication: true,
    config_required: 'is_admin',
    routes: [
      {
        url_path: '/validation',
        section_title: 'Validation',
        component: Validation,
        feature_path: 'TOUR_START.START_CHECKLIST.enabled',
      },
      {
        url_path: '/addresses',
        section_title: 'Destinataires',
        component: Addresses,
      },
      {
        url_path: '/phone-numbers',
        section_title: 'Numéros de téléphone',
        component: PhoneNumbers,
        feature_path: 'TOUR_MANAGEMENT.CONTACT_BLOCK.from_database',
      },
      {
        url_path: '/reserves/management',
        section_title: 'Catégories anomalies',
        component: ReserveReasons,
        feature_path: 'TOUR_STEP.STEP_ACTIONS.cancel.reasonAttendance.enabled',
      },
      {
        url_path: '/users',
        section_title: 'Utilisateurs',
        component: Users,
      },
      {
        url_path: '/documents',
        section_title: 'Documents',
        component: Documents,
      },
      {
        url_path: '/invoices',
        section_title: 'Factures',
        component: Admin,
      },
      {
        url_path: '/addfile',
        section_title: 'Import Excel',
        component: AddFile,
        feature_path: 'OTHERS.UPLOAD.canUploadTourWithExcel',
      },
    ],
  },
];

export const technicalRoutes = [
  {
    url_path: '/login',
    component: Login,
    public: true,
  },
  {
    url_path: '/help',
    component: Help,
    public: true,
  },
  {
    url_path: '/forgot',
    component: Forgot,
    public: true,
  },
  {
    url_path: '/reset-password/:token',
    component: ResetPassword,
    public: true,
  },
  {
    url_path: '/tour/:id',
    component: Tour,
  },
  {
    url_path: '/fleet-management',
    component: FleetManagement,
  },
  {
    url_path: '/truck-assignments',
    component: TruckAssignments,
  },
];
